module.exports = __webpack_public_path__ + "img/trash.d8f16d20.svg";